<template>
	<div>
    <div class="popup_high_right create-tracking-codes-popup"
         :class="['level-'+level,{}]">
      <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            New tracking code
		            <span></span>
	            </h3>

	            <div class="layout-column flex">

		            <div class="layout-row margin-b-20">
			            <input-field class="flex margin-t-25" label="Name" placeholder="New tracking code"
			                         info="To help you identify what this code is about."
			                         v-model="code.name" tabindex="0"/>
		            </div>

		            <div class="layout-row margin-b-20">
			            <div class="layout-column">
				            <v-switch label="Lazy load"
				                      :info="`We highly recommend enabling lazy loading for external codes`"
				                      v-model="code.lazy_load" :value="code.lazy_load" />
				            <div v-if="code.lazy_load">
					            <input-field label="Delay (ms)" small class="margin-t-10"
					                         :min="0" :max="9999999" :step="100" type="number"
					                         v-model.number="code.delay" append="ms"  />
				            </div>
			            </div>
			            <div class="flex"></div>
			            <div class="layout-column">
				            <label class="label margin-b-10">Code placement</label>
				            <v-radio class="margin-b-10" v-model="code.type" value="body"
				                     label="Append to page body (recommended)" />
				            <v-radio v-model="code.type" value="head" label="Append to page head" />
			            </div>
		            </div>

		            <div class="flex layout-column">
<!--			            <CodeEditor theme="light" height="100%" :languages="['HTML']" class="" v-model="code.html" />-->

                <prism-editor class="my-editor " :class="{'focused':editorFocused}"
                              v-model="code.html" :highlight="highlighter"
                              :line-numbers="true" @input="" :tabSize='3' :autoStyleLineNumbers="false"
                              @focus="editorFocused=true" @blur="editorFocused=false" />
			            <div>
<!--				            <span>{{// chars}} / 65,000</span>-->
			            </div>
		            </div>
	            </div>

	            <div style="min-height: 10px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button :label="`${code.id>0?'Update':'Create'} code`"
		              @click="save" :loading="saving" />
		    <v-button label="Cancel" border @click="$emit('close')" />
	    </div>


    </div>

			<popup-backdrop v-if="codeOpen" @close="codeOpen=false">
<!--				<customer-details-new :level="level+1" :customer-id="order.customer_id"-->
<!--				                      @deleted="customerOpen=false"-->
<!--				                      @close="customerOpen=false" @done="customerOpen=false" />-->
			</popup-backdrop>

	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import numbers from "@/helpers/numbers";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import {mapGetters} from "vuex";
import TrackingCodeEntry from "@/views/funnels/funnel-plus/funnel/tracking_codes/tracking_code_entry";
import VRadio from "@/components/base/v-radio";
import VSwitch from "@/components/base/v-switch";
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

export default {
	name: "create-tracking-codes-popup",
	mixins: [API],
	components: {
		VSwitch,
		VRadio,
		TrackingCodeEntry,
		QuickActionsBtn,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			editorFocused: false,
			codeOpen: false,
			saving: false,
			orderMenuLoading: false,
			loading: false,
			code: {
				user_id: this.$store.state.userInfo.id,
				funnel_id: this.funnelId,
				name:"My new tracking code",
				type:'body',
				lazy_load: true,
				delay: 3000,
				html: "<!-- HTML -->\n",
				order_index: 0,
			},
		}
	},
	computed:{
		...mapGetters(['setCodesStore','getCodesStore']),
		// localDate(){
		// 	return moment(this.order.created_at).format("DD MMMM YYYY, HH:mm:ss")
		// },

		codes(){
			return this.getCodesStore;
		}
	},
	methods: {
		highlighter(code) {
			return highlight(code, languages.markup, "html");
		},
		menuClick(e){
			if (e.action==='Archive'||e.action==='Unarchive') {
				this.archiveOrder();
			} else if (e.action==='Cancel order') {
				this.cancelOrderOpen = true;
			} else if (e.action==='Delete order') {
				this.deleteOrderOpen = true;
			} else if (e.action==='Fulfill') {
				this.fulfillOrderOpen = true;
			} else if (e.action==='Refund') {
				this.refundOpen = true;
			} else if (e.action==='Update tracking info') {
				this.addTrackingInfoOpen = true;
			}
		},
		roundPrice(n) {
			return numbers.round_to_two(n)
		},
		closePopup() {
			this.$emit('close')
		},
		async archiveOrder(){
			try {
				this.orderMenuLoading = true;

				let order = await this.api.orders.archiveToggle(this.orderId);
				if (order.error) this.$error(order.error);
				else {
					this.order.is_archived = order.is_archived;
					let o = this.getOrdersStore.find(x=>x.id===this.order.id);
					if (o) {
						o.is_archived = order.is_archived;
					}
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.orderMenuLoading = false;
			}
		},
		async loadCustomerBrief() {
			try {
				this.loadingCustomer = true;
				this.customer = {};
				let c = await this.api.customers.get(this.order.customer_id, true);
				if (c.error) this.customer = {};
				else this.customer = c;
				this.$store.dispatch("setCurrentCustomer", this.customer)
			} catch (e) {
				this.$warn(e, 'Failed to load customer details! try again later.')
			} finally {
				this.loadingCustomer = false;
			}
		},

		async save() {
			try {
				this.saving = true;

				this.code.funnel_id = this.funnelId;

				this.code.order_index = this.getCodesStore.length; // append to the end.

				let code = await this.api.codes.create(this.code);
				if (code.error) this.$error(code.error);
				else {
					this.getCodesStore.push(code);
					this.$emit('done', code)
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		}
		//API
		// async init() {
		// 	try {
		// 		this.loading = true;
		// 		this.codes = [];
		//
		// 		this.codes = await this.api.codes.get(this.funnelId);
		// 		this.$store.dispatch("setCodesStore", this.codes)
		// 	} catch (e) {
		// 		this.$error(e);
		// 	} finally {
		// 		this.loading = false;
		// 	}
		// },
	},
	created() {
		// this.init();
	},
}
</script>
<style lang="scss" scoped>
.create-tracking-codes-popup {
	padding: 0;
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	.my-editor {
		font-family: Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
		//height: 25%;
		border-radius: 4px;
		border: 1px solid #ececec;
		background-color: whitesmoke;
		&.focused {
			border: 1px solid $blue;
		}
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
